import { useMemo } from "react";
import useMousePosition from "../../hooks/useMousePosition";

export default function PageNotFound() {
  const screenWidth = useMemo(() => {
    return window.innerWidth;
  }, []);
  const mouseXY = useMousePosition();

  const face = (() => {
    if (mouseXY.x < (screenWidth / 2 - 100)) {
      return <h1>(x_x&nbsp;&nbsp;)</h1>;
    } else if (mouseXY.x > (screenWidth / 2 + 100)) {
      return <h1>(&nbsp;&nbsp;x_x)</h1>;
    }
    return <h1>(&nbsp;x_x&nbsp;)</h1>;
  })();

  return (
    <main className="centered">
      {face}
      <div>This page doesn't exist</div>
    </main>
  );
}